(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("../../components/TransitionResponsive"), require("../../utils/transitions"));
	else if(typeof define === 'function' && define.amd)
		define(["../../components/TransitionResponsive", "../../utils/transitions"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("../../components/TransitionResponsive"), require("../../utils/transitions")) : factory(root["../../components/TransitionResponsive"], root["../../utils/transitions"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__216__, __WEBPACK_EXTERNAL_MODULE__387__) {
return 